import { Box } from '@mui/material';
import { DARK } from 'constants/colors';

type Props = {
  address?: string;
};

const AddressSection = ({ address }: Props) => {
  return (
    <Box
      fontFamily="SourceSansPro-Regular"
      fontSize={12}
      padding={1}
      sx={{
        display: 'flex',
        lineHeight: 1.1,
        color: DARK
      }}
    >
      {address}
    </Box>
  );
};

export default AddressSection;
